"use client";

// src/focusable/focusable-context.tsx
import { createContext } from "react";
var FocusableContext = createContext(true);

export {
  FocusableContext
};
